module.exports = __webpack_public_path__ + "media/new_messages_girl_voice.e887b547.mp3";